<template>
  <div class="consultationPage">
    <job-header-simple :header_title="header_title"></job-header-simple>
    <van-cell-group>
      <van-field
        v-model="username"
        placeholder="您的姓名"
        :error-message="messageUser"
        @blur="validInput"
      />
      <van-field
        v-model="phone"
        type="tel"
        placeholder="您的电话"
        :error-message="messageTel"
        @blur="validInput"
      />
      <van-field
        v-model="message"
        rows="2"
        autosize
        type="textarea"
        maxlength="60"
        placeholder="留言内容"
        show-word-limit
        :error-message="messageText"
        @blur="validInput"
      />

      <div class="btnBox">
        <van-button round type="info" size="normal" class="btn_theme" @click="handleSubmit">提 交</van-button>
      </div>
    </van-cell-group>
  </div>
</template>

<script>
import { Button, Field, Toast, CellGroup } from "vant";
import jobHeaderSimple from "@/components/header/header.vue";
import store from "@/store";
import api from "@/api/list";

export default {
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [Toast.name]: Toast,
    [CellGroup.name]: CellGroup,
    jobHeaderSimple
  },
  data() {
    return {
      header_title: "在线咨询",
      username: store.getters.jwtDecode.name,
      phone: store.getters.jwtDecode.sub,
      message: "",
      messageUser: "",
      messageTel: "",
      messageText: "",
      type: ""
    };
  },
  created() {
    this.initType();
  },
  methods: {
    initType() {
      api.getDataDictList({ group: "contentFeedbackType" }).then(res => {
        if (res.data.status == "200") {
          this.type = res.data.data.filter(
            item => item.code === "bjnews_feedback"
          )[0].id;
        }
      });
    },
    handleSubmit() {
      if (this.validInput()) {
        let parm = {
          type: this.type,
          content: this.message,
          employeeName: this.username,
          mobile: this.phone
        };
        api.contentFeedbackPostAction(parm, { method: "post" }).then(res => {
          if (res.data.status == "200") {
            //此处写异步逻辑
            this.$toast("留言提交成功！");
            this.username = "";
            this.phone = "";
            this.message = "";
          } else {
            Toast({
              type: "error",
              forbidClick: true, // 禁用背景点击
              message: res.data.message
            });
          }
        });
      }
    },
    validInput() {
      if (this.username == "") {
        this.messageUser = "请填写用户名";
        return false;
      } else {
        this.messageUser = "";
      }

      if (this.phone == "") {
        this.messageTel = "请填写电话号码";
        return false;
      } else if (this.phone.length != 11) {
        this.messageTel = "请填写正确的电话号码";
        return false;
      } else {
        this.messageTel = "";
      }

      if (this.message == "") {
        this.messageText = "请填写留言内容";
        return false;
      } else {
        this.messageText = "";
      }

      return true;
    }
  }
};
</script>

<style lang="less" scoped>
.consultationPage {
  /deep/ .van-cell-group {
    margin: 20px;
    padding: 20px 24px;
    border-radius: 10px;

    .van-cell {
      background-color: #f9f9f9;
      margin-bottom: 24px;
      border-radius: 6px;
      &:not(:last-child)::after {
        display: none;
      }

      .van-field__error-message {
        position: absolute;
        right: 0;
        top: 0;
      }
    }
  }

  .btnBox {
    text-align: center;
    margin: 20px 12px 12px;
  }

  .btn_theme {
    width: 50%;
    font-size: 16px;
  }
}
</style>